import "../shared/components/modal.js";

jQuery(function () {
  jQuery(document).on("click", "[data-toggle~=assessment-modal]", function (e) {
    e.preventDefault();

    var assessmentModal = new Modal();
    assessmentModal.setBody(
      '<iframe style="border:none; width:100%; height: ' +
        jQuery(this).data("assessment-height") +
        'px;" src="' +
        jQuery(this).data("assessment-url") +
        '"></iframe>',
    );
    assessmentModal.header.remove();
    assessmentModal.show();
  });
});
